import { CF } from '@dadohr/shared/versions';

import {
  callFirebaseFunction,
  useFirebaseFunction
} from '../../../../../../services/firebaseFunctions';
import { ONE_MINUTE, Timestamp } from '../../../../../../services/time';

export const useCalendarList = (orgId: string) => {
  return useFirebaseFunction<
    {
      id: string;
      name: string;
      color: string;
      canEdit: string;
    }[]
  >(CF.microsoft.calendar.getList, { orgId }, [orgId], ONE_MINUTE * 5);
};

export const getMatchingCalendarEvents = (
  orgId: string,
  calendarId: string,
  args: {
    q: string;
    minDate?: Timestamp;
    maxDate?: Timestamp;
    maxResults?: number;
  }
) => {
  return callFirebaseFunction<
    {
      calendarId: string;
      eventId: string;
      eventName: string;
      htmlLink: string;
      startTime: string | null; // ISO string
    }[]
  >(CF.microsoft.calendar.getMatchingEvents, {
    orgId,
    calendarId,
    q: args.q,
    minDate: args.minDate?.toMillis(),
    maxDate: args.maxDate?.toMillis(),
    maxResults: args.maxResults
  });
};
